import { Alert, Button, Card, Table } from "flowbite-react";
import React, { useEffect, useRef, useState } from "react";
import { isValidCNPJ, isValidCPF } from "../../utils/utils";
import axios from "../../config/axiosInstance";
import { QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import TitleStripe from "../common/TitleStripe";
import CardQueryDescription from "../common/CardQueryDescription";
import QueryInput from "../inputs/QueryInput";
import SliderToPreview from "../common/SliderToPreview";
import QueryLoading from "../common/QueryLoading";
import AvisoCard from "../common/query/AvisoCard";
import PendenciasFinanceiras from "../common/query/PendenciasFinanceiras";
import NoOcurrence from "../common/query/NoOcurrence";
import Protestos from "../common/query/Protestos";
import ChequesSemFundos from "../common/query/ChequesSemFundos";
import QuadroSocietario from "../common/query/QuadroSocietario";
import moment from "moment";
import FooterQuery from "./FooterQuery";
import { FaPrint } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";

const CompletaPlusCPFQuery = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
  hasHeaderPDF = "true",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [error, setError] = useState("");
  const [errorData, setErrorData] = useState("");
  const [resumoRetorno, setResumoRetorno] = useState(null);
  const [data, setData] = useState(null);
  const [document, setDocument] = useState("");
  const componentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: componentRef });

  useEffect(() => {
    if (dataFromLocalStorage) {
      setData(dataFromLocalStorage.consultaCredito);
      setDocument(dataFromLocalStorage?.consultaCredito?.dadosCadastrais?.cpf);
    }
  }, []);

  const fetchInfo = async (type) => {
    return await axios(
      `${QUERIES.GET_V2_QUERY}/completa-plus-cpf/${info.replace(/\D/g, "")}`
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setDocument(info);
    const unmaskedValue = info.replace(/\D/g, "");
    let isValid = true;
    let type = "F";

    if (unmaskedValue.length <= 11) {
      if (!isValidCPF(unmaskedValue)) {
        setError("CPF inválido!");
        isValid = false;
      }
    } else {
      if (!isValidCNPJ(unmaskedValue)) {
        setError("CNPJ inválido!");
        isValid = false;
      }
      type = "J";
    }

    if (isValid) {
      try {
        setData(null);
        setIsLoading(true);
        setErrorData("");
        const { data: dados } = await fetchInfo(type);
        setData(dados?.data);
        setResumoRetorno(dados?.data?.resumoRetorno);
      } catch (error) {
        setErrorData(
          typeof error?.response?.data?.message !== "object"
            ? error?.response?.data?.message
            : "Algum erro ocorreu com sua consulta"
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setData(null);
    }
  };

  console.log(data);

  const formatArraySocios = (arraySocios) => {
    return arraySocios?.map((socio) => {
      return {
        nome_empresa: socio.empresa,
        cpf_cnpj: socio.cnpj,
        data_entrada: socio.dataEntrada,
        participacao: socio.participacaoEmPorcentagem,
      };
    });
  };

  return (
    <>
      {!dataFromLocalStorage && (
        <>
          <CardQueryDescription
            title={query?.name || "Informações da consulta"}
            infos={[
              "Pendências Financeiras",
              "Protestos",
              "Cheques sem fundos",
              "Negativações",
            ]}
            price={selectedPrice}
          >
            <form
              className="flex flex-col gap-2 bg-white p-2 rounded-lg shadow-md w-fit"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col md:flex-row gap-2 items-center">
                <QueryInput
                  info={info}
                  setInfo={setInfo}
                  isLoading={isLoading}
                  error={error}
                  type="CPF"
                />
                {!errorData && data && (
                  <Button
                    className="bg-gray-600"
                    onClick={() => reactToPrintFn()}
                  >
                    <div className="flex gap-2 items-center">
                      <FaPrint />
                      <div>Imprimir</div>
                    </div>
                  </Button>
                )}
              </div>
            </form>
          </CardQueryDescription>
        </>
      )}

      <SliderToPreview />

      {errorData && (
        <Alert color="failure" icon={HiInformationCircle}>
          <span className="font-medium">{errorData}</span>
        </Alert>
      )}
      {!errorData && (
        <div
          className={`overflow-x-scroll print-content mobile-fit ${
            data || isLoading ? "block" : "hidden"
          }`}
          ref={componentRef}
        >
          {!isLoading ? (
            <Card className="relative overflow-hidden card-pdf p-5">
              <HeaderQuery
                title={query?.name}
                hasHeader={hasHeaderPDF}
                titleReport={document}
              />
              <TitleStripe>Informações:</TitleStripe>
              <div className="flex gap-20 text-sm">
                <div className="flex-1">
                  <div className="mb-3">
                    <span className="font-semibold">Documento: </span>
                    {document}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Tipo: </span>
                    {document?.length === 18 ||
                    (!document?.includes("-") && document.length === 14)
                      ? "Jurídica"
                      : "Física"}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Nome: </span>
                    {
                      data?.acertaEssencialPositivo?.consultaCredito
                        ?.dadosCadastrais?.nome
                    }
                  </div>
                  <div>
                    <span className="font-semibold">Data: </span>
                    {resumoRetorno?.dataConsulta}
                  </div>
                </div>
              </div>
              <TitleStripe>Quadro de avisos</TitleStripe>
              <div className="container-alerts four-columns">
                <AvisoCard
                  title="Pendências Serasa"
                  hasRestrictions={
                    +data?.crednet?.consultaCredito?.resumoConsulta
                      ?.pendenciasFinanceiras?.quantidadeTotal > 0
                  }
                  messageError={`${data?.crednet?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal} ocorrências`}
                />
                <AvisoCard
                  title="Pendências QUOD"
                  hasRestrictions={
                    +data?.quod?.resumoConsulta?.pendenciasFinanceiras
                      ?.quantidadeTotal > 0
                  }
                  messageError={`${data?.quod?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal} ocorrências`}
                />

                <AvisoCard
                  title="Negativações"
                  hasRestrictions={data?.spcSerasaPF?.serasa?.length > 0}
                  messageError={`${data?.spcSerasaPF?.serasa?.length} ocorrências`}
                />
                <AvisoCard
                  title="Protestos"
                  hasRestrictions={
                    +data?.acertaEssencialPositivo?.consultaCredito
                      ?.resumoConsulta?.protestos?.quantidadeTotal > 0
                  }
                  messageError={`${data?.acertaEssencialPositivo?.consultaCredito?.resumoConsulta?.protestos?.quantidadeTotal} ocorrências`}
                />
                <AvisoCard
                  title="Protesto Nacional"
                  hasRestrictions={data?.protestoNacional?.length > 0}
                  messageError={`${data?.protestoNacional?.resumoConsulta?.protestos?.valorTotal} ocorrências`}
                />
                <AvisoCard
                  title="Cheques sem Fundo"
                  hasRestrictions={
                    +data?.acertaEssencialPositivo?.consultaCredito
                      ?.resumoConsulta?.chequesSemFundo?.quantidadeTotal > 0
                  }
                  messageError={`${+data?.acertaEssencialPositivo
                    ?.consultaCredito?.resumoConsulta?.chequesSemFundo
                    ?.quantidadeTotal} ocorrências`}
                />
              </div>

              <div>
                <TitleStripe className="mb-3">
                  Pendências Financeiras
                </TitleStripe>
                {data?.acertaEssencialPositivo?.consultaCredito
                  ?.pendenciasFinanceiras?.length > 0 ? (
                  <PendenciasFinanceiras
                    pendenciasFinanceiras={
                      data?.acertaEssencialPositivo?.consultaCredito
                        ?.pendenciasFinanceiras
                    }
                  />
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-5">Pendências Serasa</TitleStripe>

                {data?.crednet?.consultaCredito?.pendenciasFinanceiras?.length >
                0 ? (
                  <>
                    <PendenciasFinanceiras
                      quantidadeTotal={
                        data?.crednet?.consultaCredito?.resumoConsulta
                          ?.pendenciasFinanceiras?.quantidadeTotal
                      }
                      valorTotal={
                        data?.crednet?.consultaCredito?.resumoConsulta
                          ?.pendenciasFinanceiras?.valorTotal
                      }
                      pendenciasFinanceiras={
                        data?.crednet?.consultaCredito?.pendenciasFinanceiras
                      }
                    />
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-5">Pendências Quod</TitleStripe>

                {data?.quod?.pendenciasFinanceiras?.length > 0 ? (
                  <>
                    <PendenciasFinanceiras
                      quantidadeTotal={
                        data?.quod?.resumoConsulta?.pendenciasFinanceiras
                          ?.quantidadeTotal
                      }
                      valorTotal={
                        data?.quod?.resumoConsulta?.pendenciasFinanceiras
                          ?.valorTotal
                      }
                      pendenciasFinanceiras={data?.quod?.pendenciasFinanceiras}
                    />
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">Negativações</TitleStripe>
                {data?.spcSerasaPF?.serasa?.length > 0 ? (
                  <PendenciasFinanceiras
                    pendenciasFinanceiras={data?.spcSerasaPF?.serasa}
                  />
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">Protestos</TitleStripe>
                {data?.acertaEssencialPositivo?.consultaCredito?.protestos
                  ?.length > 0 ? (
                  <Protestos
                    protestos={
                      data?.acertaEssencialPositivo?.consultaCredito?.protestos
                    }
                  />
                ) : (
                  <NoOcurrence />
                )}
              </div>
              <div>
                <TitleStripe className="mb-5">Protesto Nacional</TitleStripe>
                {!!data?.defineLimite?.protestos?.total_protestos ? (
                  <Protestos
                    quantidadeTotal={
                      data?.protestoNacional?.resumoConsulta?.protestos
                        ?.quantidadeTotal
                    }
                    valorTotal={
                      data?.protestoNacional?.resumoConsulta?.protestos
                        ?.valorTotal
                    }
                    protestos={data?.protestoNacional?.ocorrencias}
                  />
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">Cheques sem fundo</TitleStripe>
                {data?.acertaEssencialPositivo?.consultaCredito?.chequesSemFundo
                  ?.length > 0 ? (
                  <ChequesSemFundos
                    chequesSemFundos={
                      data?.acertaEssencialPositivo?.consultaCredito
                        ?.chequesSemFundo
                    }
                  />
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <FooterQuery hasHeader={hasHeaderPDF} />
            </Card>
          ) : (
            <QueryLoading />
          )}
        </div>
      )}
    </>
  );
};

export default CompletaPlusCPFQuery;
